<mat-card id="app-add-business-manager">
  <mat-radio-group [(ngModel)]="selectedBusinessManager">
    <label>{{ 'business-manager/select' | translate }}:</label>
    <mat-radio-button
      *ngFor="let candidateBusiness of candidateBusinesses"
      [value]="candidateBusiness.external_id"
      [disabled]="candidateBusiness.isAlreadyConnected">
      <span class="radio-button-text">{{ candidateBusiness.external_id }} - {{ candidateBusiness.name }}</span>
      <a class="business-manager-option-link" href="candidateBusiness.linkToBusinessManager" target="_blank">?</a>
    </mat-radio-button>
    <button mat-flat-button color="accent" (click)="connectBusinessManager()">
      {{ 'business-manager/connect' | translate }}
    </button>
  </mat-radio-group>
  <div class="alc-spinner-wrapper" *ngIf="isQueryOngoing">
    <mat-progress-spinner diameter="50" mode="indeterminate" color="accent"></mat-progress-spinner>
  </div>
</mat-card>
